import {Component} from '@angular/core'

@Component({
  selector: 'smt-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {

}
